import { InvoiceBase } from './base-classes/invoice-base'
import { auth } from './auth.module'

const invoiceBase = new InvoiceBase()

invoiceBase.state.all.defaultFilter = {
  customerName: null,
  projectCode: null,
  projectOwnerUserInitials: auth.state.user.initials,
  orderByColumn: 'serialNumber',
  orderByDescending: true,
  invoiceType: null,
  status: 'Overdue'
}

export const invoicesOverdue = {
  namespaced: true,
  state: invoiceBase.state,
  actions: invoiceBase.actions(),
  mutations: invoiceBase.mutations(),
  getters: invoiceBase.getters()
}



// WEBPACK FOOTER //
// ./src/store/invoice-overdue.module.js